import type { Service, TeamMember, Stat } from '@/lib/index';
import { IMAGES } from '@/assets/images';

export const services: Service[] = [
  {
    id: 'digital-twin',
    title: '数字孪生与全球镜像运营',
    description: '作为迪拜DMCC官方国际服务商（ISP），为中国企业提供远程合规的数字孪生主体设立服务，实现免差旅、零物理存在的全球化运营。',
    icon: 'Globe',
    features: [
      'DMCC官方ISP特权资质',
      '远程视频见证开户',
      '数字化文件递交系统',
      '虚拟办公室与商业地址',
      '全程中文服务支持',
      '7-14个工作日快速设立'
    ],
    benefits: [
      '无需亲赴迪拜，节省差旅成本',
      '合规持有阿联酋商业实体',
      '享受0%企业所得税优惠',
      '开立国际银行账户',
      '全球贸易与投资便利',
      '品牌国际化形象提升'
    ]
  },
  {
    id: 'vertical-strategy',
    title: '垂直领域战略穿透',
    description: '聚焦游戏电竞、RWA代币化、人工智能算力三大垂直领域，提供从主体设立到业务落地的全链条战略咨询与执行服务。',
    icon: 'Target',
    features: [
      '游戏出海合规架构设计',
      'RWA资产代币化方案',
      'AI算力镜像主体设立',
      '垂直领域牌照申请',
      '业务模式合规审查',
      '行业资源对接'
    ],
    benefits: [
      '规避政策风险',
      '加速业务出海',
      '获取行业牌照',
      '对接国际资本',
      '建立合规护城河',
      '抢占市场先机'
    ]
  },
  {
    id: 'cross-domain',
    title: '跨域运营与合规管理',
    description: '基于Resolution No.11法规，协助企业打通自由区与本土市场壁垒，实现迪拜本土业务拓展与跨境合规运营。',
    icon: 'Network',
    features: [
      'Resolution No.11许可申请',
      '自由区与本土业务打通',
      '本土合作伙伴对接',
      '跨境合规审查',
      '持续合规监控',
      '政府关系维护'
    ],
    benefits: [
      '突破自由区限制',
      '拓展本土市场',
      '降低合规风险',
      '提升运营效率',
      '获取政府支持',
      '建立长期竞争力'
    ]
  }
];

export const team: TeamMember[] = [
  {
    id: 'founder-ceo',
    name: '廖怀南',
    nameEn: 'Aaron Liao',
    position: '创始人 & CEO',
    bio: '资深文化科技行业领袖，职业生涯逾二十年。曾任阿里巴巴文化娱乐集团优酷总经理，与迪士尼、华纳兄弟、环球影业缔结战略合作，并亲赴MIPCOM谈判获取Stan Lee遗产IP授权；现任上海超星原力文化科技公司创始人兼CEO，专注中国青年文化生态构建。同时担任Bridge Alliance Advisory Board Member、深圳何香凝美术馆艺术顾问及南山博物馆理事。',
    avatar: IMAGES.IMG_4276_41,
    expertise: ['阿里巴巴优酷总经理', 'Bridge Alliance顾问', '上海超星原力创始人', '全球IP战略', '文化科技融合', '中阿商业拓展']
  },
  {
    id: 'partner-cfo',
    name: '钟茜',
    nameEn: 'Grace Zhong',
    position: '合伙人 & CFO',
    bio: '具备中国、香港及中东、北非、欧洲跨市场经验的TMT战略投资与平台型管理者。曾任职北京万通新发展集团（600246.SH）总裁业务助理（总监级）、光大控股特斯联集团CPO及国际业务总裁助理、华泰证券海外TMT研究分析师，主导跨境并购、AI与新能源领域战略投资，并深度参与MENA区域业务落地。伦敦大学国王学院银行与金融学硕士，持有上交所董事会秘书资格及HKSI 9牌照。',
    avatar: IMAGES.GRACE,
    expertise: ['TMT战略投资', '跨境并购与资本运作', 'MENA区域业务', '资本市场与IR', 'AI与新能源布局', '政府与监管关系']
  },
  {
    id: 'partner-clo',
    name: '付慧中',
    nameEn: 'Selena Fu',
    position: '合伙人 & CLO',
    bio: '香港中文大学法律博士（JD），持有中、美两国律师执业资格及上市公司董事会秘书资格。曾任职于香港红圈律师事务所、证券公司及上市公司，服务多家大型国央企及跨国公司。执业领域涵盖跨境投资与并购、IPO、公司治理与股权结构设计、虚拟数字资产牌照申请及合规管理。现任文森律师事务所合伙人，资本市场与数据合规负责人。',
    avatar: IMAGES.SELENA,
    expertise: ['跨境投资与并购', 'IPO与资本市场', '公司治理与股权设计', '虚拟数字资产合规', '金融牌照申请', '数据合规管理']
  }
];

export const stats: Stat[] = [
  {
    label: '服务企业',
    value: '200+',
    icon: 'Building2'
  },
  {
    label: '资产管理规模',
    value: '50亿美元',
    icon: 'TrendingUp'
  },
  {
    label: '成功率',
    value: '98%',
    icon: 'Award'
  },
  {
    label: '覆盖国家',
    value: '15+',
    icon: 'Globe'
  }
];